import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase/config'

import DefaultLayout from '../layouts/DefaultLayout.vue'
import PreviewLayout from '../layouts/PreviewLayout.vue'


import Dashboard from '../views/Dashboard.vue'
import Tag from '../views/Tag.vue'
import NewTag from '../views/NewTag.vue'
import Details from '../views/Details.vue'
import Export from '../views/Export.vue'
import Login from '../views/Login.vue'
import Wspierajacy from '../views/Wspierajacy.vue'
import NewVideos from '../views/NewVideos.vue'
import Articles from '../views/Articles.vue'
import Influencers from '../views/Influencers.vue'
import Tags from '../views/Tags.vue'
import Stats from '../views/Stats.vue'
import OGPreviewPage from '../views/OGPreviewPage.vue'


import Preview from '../Preview.vue'



const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/new',
    name: 'NewTag',
    component: NewTag,
    meta: { requiresAuth: true }
  },
  {
    path: '/tag/:id',
    name: 'tag',
    component: Tag,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/preview/:id',
    name: 'preview',
    component: Preview,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/og-preview/:id',
    name: 'og-preview',
    component: OGPreviewPage,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/details',
    name: 'Details',
    component: Details,
    meta: { requiresAuth: true }
  },
  {
    path: '/export',
    name: 'Export',
    component: Export,
    meta: { requiresAuth: true }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/wspierajacy',
    name: 'Wspierajacy',
    component: Wspierajacy,
    meta: { requiresAuth: true }
  },
  {
    path: '/new-videos',
    name: 'NewVideos',
    component: NewVideos,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles',
    name: 'articles',
    component: Articles,
    meta: { requiresAuth: true }
  },
  {
    path: '/influencers',
    name: 'influencers',
    component: Influencers,
    meta: { requiresAuth: true }
  },
  {
    path: '/tags',
    name: 'tags',
    component: Tags,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

// const routes = [
//   {
//     path: '/',
//     component: DefaultLayout,
//     children: [
//       {
//         path: '',
//         name: 'dashboard',
//         component: Dashboard,
//       },
//         // {
//         //   path: '/new',
//         //   name: 'NewTag',
//         //   component: NewTag
//         // },
//         // {
//         //   path: '/tag/:id',
//         //   name: 'tag',
//         //   component: Tag,
//         //   props: true,
//         // },
      
//     ]
//   },
//   {
//     path: '/preview/:id',
//     name: 'preview',
//     component: PreviewLayout,
//     children: [
//       {
//         path: '',
//         component: Preview,
//         props: true,
//       }
//     ]
//   }
// ]




const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Router guard - sprawdza autoryzację przed każdą nawigacją
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  // Allow public OG preview without auth for server-side rendering/screenshotting
  if (to.name === 'og-preview' && (to.query.public === '1' || to.query.public === 'true')) {
    return next()
  }

  // Czekaj na inicjalizację Firebase Auth
  await new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
  
  // Sprawdź czy użytkownik jest zalogowany
  const currentUser = auth.currentUser
  
  if (requiresAuth && !currentUser) {
    // Jeśli strona wymaga autoryzacji, ale użytkownik nie jest zalogowany
    next({ name: 'Login' })
  } else if (to.name === 'Login' && currentUser) {
    // Jeśli użytkownik jest zalogowany i próbuje wejść na stronę logowania
    next({ name: 'dashboard' })
  } else {
    // Wszystko OK, przejdź do żądanej strony
    next()
  }
})

export default router
